import { render } from "./PlansTab.vue?vue&type=template&id=58587b67&scoped=true"
import script from "./PlansTab.vue?vue&type=script&lang=js"
export * from "./PlansTab.vue?vue&type=script&lang=js"

import "./PlansTab.vue?vue&type=style&index=0&id=58587b67&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58587b67"]])

export default __exports__